import toastMessage from "../toastMessage";
import formatSelectData from "../formatSelectData";
import { getStorage } from "../storage";
import language from "../../language";
import { defineRole } from "../handleAccessRoles";
import { ROLE_REQUEST } from "../../constants/ROLES";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const sanitizeRequestApiParams = (params = {}) => {
  const filters = { ...params };

  const normalizeId = (value) =>
    typeof value === "object" && value !== null ? value?._id || value?.value : value;

  const toIdArray = (value) => {
    if (!Array.isArray(value)) return normalizeId(value);
    return value.map((item) => normalizeId(item));
  };

  filters.stock = toIdArray(filters.stock);
  filters.hospital = toIdArray(filters.hospital);
  filters.bloodBank = toIdArray(filters.bloodBank);

  return filters;
};

const fetchData = async (
  lng = "english",
  {
    page,
    limit,
    type,
    category,
    user,
    id,
    stock,
    requestNo,
    hospital,
    status,
    q,
    patient,
  },
) => {
  try {
    const { token, accessRole } = await getStorage();

    const canAccess = defineRole({
      roles: accessRole,
      menu: ROLE_REQUEST,
      operation: "read",
    });

    if (!canAccess) return;

    let requestBody = sanitizeRequestApiParams({
      page: page,
      limit: limit,
      category,
      user,
      id,
      requestNo: requestNo ? requestNo?.toUpperCase() : requestNo,
      bloodBank: stock,
      hospital,
      status,
      type: type === "dropdown" ? undefined : type,
      q,
      patient,
    });

    console.log("Request Body >>>>>:", requestBody);

    if (requestNo) {
      delete requestBody.stock;
      delete requestBody.hospital;
    }

    const options = {
      method: "GET",
      url: `${API_URL}/bloodrequest`,
      params: requestBody,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    console.log("Request Body >>>>>:", options);

    const queryRes = await api(options);

    const response = queryRes.data || {};
    let data = response.data;
    const count = response.count;
    const totalRecords = response.totalRecords;

    if (!Array.isArray(data)) {
      data = Array.isArray(response) ? response : [];
    }

    if (type === "dropdown") {
      return formatSelectData(queryRes.data, "description", "_id");
    }

    return {
      data,
      count,
      totalRecords:
        typeof totalRecords === "number" ? totalRecords : Array.isArray(data) ? data.length : 0,
    };
  } catch (error) {
    toastMessage("error", error);
  }
};

export default fetchData;

export const deleteRequest = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_REQUEST,
      operation: "read",
    });

    if (!canAccess) return;

    const options = {
      method: "DELETE",
      url: `${API_URL}/bloodrequest`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_request);
  } catch (error) {
    toastMessage("error", error);
  }
};

export const getBloodRequestDashboardCounts = async (
  lng = "english",
  params = {},
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_REQUEST,
      operation: "read",
    });

    if (!canAccess) return;

    const apiParams = sanitizeRequestApiParams(params);
    delete apiParams.page;
    delete apiParams.limit;

    const options = {
      method: "GET",
      url: `${API_URL}/bloodrequest/dashboard-counts`,
      params: apiParams,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const response = await api(options);
    const payload = response?.data || {};

    // Supports both direct-object and paginated wrapper shapes.
    if (payload && typeof payload === "object" && payload.data && !payload.total) {
      return payload.data;
    }

    return payload || {};
  } catch (error) {
    toastMessage("error", error);
  }
};
